import { askZotAboutSchema, type AskZotAbout } from "@zworks/console-contracts";

export type AskZotObjectKind = "run" | "approval" | "flow" | "work-item" | "usage";

const kindLabels: Record<AskZotObjectKind, string> = {
  run: "Run",
  approval: "Approval",
  flow: "Flow",
  "work-item": "Work item",
  usage: "Usage",
};

export function askZotKindLabel(kind: AskZotObjectKind): string {
  return kindLabels[kind];
}

function questionFor(kind: AskZotObjectKind, label: string): string {
  switch (kind) {
    case "run":
      return `Why did the run "${label}" end the way it did, and what should I check?`;
    case "approval":
      return `Summarise the approval "${label}" and flag the risks.`;
    case "flow":
      return `Explain the workflow "${label}" and what its runs usually cost.`;
    case "work-item":
      return `Summarise the work item "${label}" and suggest the next step.`;
    case "usage":
      return `Explain the spend behind "${label}" and what is driving it.`;
  }
}

/** Reads `about=<kind>:<id>` from the Zot page URL. An unknown kind is ignored. */
export function parseAskZotAbout(value: string | null): AskZotAbout | null {
  if (!value) return null;
  const index = value.indexOf(":");
  if (index <= 0) return null;
  const parsed = askZotAboutSchema.safeParse({
    type: value.slice(0, index).toLowerCase(),
    id: value.slice(index + 1),
  });
  return parsed.success ? parsed.data : null;
}

export function askZotHref(kind: AskZotObjectKind, id: string, label: string): string {
  const params = new URLSearchParams({
    ask: questionFor(kind, label),
    about: `${kind}:${id}`,
    chip: `${kindLabels[kind]} ${label}`,
  });
  return `/zot?${params.toString()}`;
}
